export const SUPPORT_SUBMISSION_KINDS = [
	'contact-feedback',
	'report-bug',
] as const

export type SupportSubmissionKind = (typeof SUPPORT_SUBMISSION_KINDS)[number]

/** Device and app details attached to bug reports to help reproduce issues. */
export interface BugReportContext {
	appBuild?: string
	appVersion: string
	bundleCommit: string
	colorScheme: 'dark' | 'light'
	displayMode: 'browser' | 'standalone'
	locale: string
	online: boolean
	platform: 'ios' | 'web'
	route?: string
	screen: string
	viewport: string
}

export interface SupportSubmissionPayload {
	context?: BugReportContext
	sendCopy?: boolean
	email?: string
	kind: SupportSubmissionKind
	message: string
}

export interface SupportSubmissionResponse {
	data: {
		id: string
		copyStatus?: 'sent' | 'failed'
	}
	success: true
}
